export const changeDialogVisibility = (vis) => (dispatch, getState) => {
    dispatch({
        type: "change2",
        payload: vis
    })
};